<template>
  <div class="container mb-5">
    <div v-if="videos" class="row">
      <div v-if="video.snippet.title !== 'Private video' && video.snippet.title !=='Deleted video'" v-for="video in videos" class="col-lg-4 col-md-6 col-12 my-4">
        <div class="w-100 position-relative">
          <span class="overlay_video_archive cursor-pointer d-flex center-vertically" @click="getModalInfo(video)"
                role="button" data-toggle="modal" data-target="#videoModal">
            <svg class="video-overlay-play-button" viewBox="0 0 200 200" alt="Play video" width="250px" height="250px">
              <polygon points="70, 55 70, 145 145, 100" fill="#fff"/>
            </svg>
          </span>
          <img v-if="video.snippet.thumbnails && video.snippet.thumbnails.medium" :src="video.snippet.thumbnails.medium.url"
               class="img-fluid border cursor-pointer w-100"/>
        </div>
        <h4 class="h5 my-3 cursor-pointer" role="button" @click="getModalInfo(video)" data-toggle="modal"
            data-target="#videoModal">{{ video.snippet.title }}</h4>
      </div>


      <div class="col-md-2 offset-md-5">
        <button v-if="!loading && nextPage !== 'Done'"
                class="btn btn-dark  w-100 action_box_full_width_mobile rounded-0 mt-3 mt-md-5 mb-3 mb-md-5" @click="getVideos(numberOfRequests)">
          {{ __('show-more') }}
        </button>
        <div class="loader center-vertically my-5" v-if="loading">
          <svg version="1.1" id="da-loader" xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50"
               style="enable-background:new 0 0 50 50;" xml:space="preserve">
          <path fill="#000"
                d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"/></path>
        </svg>
        </div>
      </div>
    </div>
    <!-- Video Modal -->
    <div v-if="modal" class="modal fade p-0" id="videoModal" tabindex="-1" role="dialog" aria-labelledby="videoModal"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="video">
        <div class="modal-content rounded-0">
          <div class="modal-header">
            <h4 class="modal-title h5">{{ modal.videoTitle }}</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <iframe class="modal-body p-0"
                  width="100%" height="365px"
                  :src="modal.videoUrl"
                  frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>
          </iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TV',
  data: function () {
    return {
      loading: true,
      videos: [],
      modal: {
        videoTitle: '',
        videoUrl: ''
      },
      nextPage: null,
      numberOfRequests: 3
    }
  },
  computed: {
    console: () => console,
    window: () => window,
  },
  methods: {
    __: function (key) {
      return window.AG.trans[key];
    },
    getModalInfo(video) {
      this.modal.videoTitle = video.snippet.title;
      this.modal.videoUrl = 'https://www.youtube.com/embed/' + video.snippet.resourceId.videoId;
    },
    getVideos(numberOfRequests) {
      this.loading = true;
      let self = this;
      if (this.nextPage !== 'Done') {
        return new Promise((resolve, reject) => {
          axios.post('/api/videoArchive', {
            pageToken: self.nextPage
          }).then(response => {
            this.videos = this.videos.concat(response.data.items);
            if (response.data.nextPageToken) {
              this.nextPage = response.data.nextPageToken;
            } else {
              this.nextPage = 'Done';
            }
            if (numberOfRequests > 1) {
              numberOfRequests--;
              this.getVideos(numberOfRequests);
            }
            this.loading = false;
            resolve(response.data);
          }, error => {
            console.log(error)
            reject(error);
          })
        });
      }
      this.loading = false;
    }
  },
  mounted() {
    this.getVideos(this.numberOfRequests);

    //Clear video url when closing modal
    let self = this;
    $('#videoModal').on('hidden.bs.modal', function () {
      self.modal.videoUrl = '';
    })
  }
}
</script>
